var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0013 0.666672C52.4113 0.666672 67.3346 15.59 67.3346 34C67.3346 52.41 52.4113 67.3333 34.0013 67.3333C15.5913 67.3333 0.667969 52.41 0.667969 34C0.667969 15.59 15.5913 0.666672 34.0013 0.666672ZM34.0013 7.33334C26.9289 7.33334 20.1461 10.1429 15.1451 15.1438C10.1442 20.1448 7.33464 26.9276 7.33464 34C7.33464 41.0724 10.1442 47.8552 15.1451 52.8562C20.1461 57.8572 26.9289 60.6667 34.0013 60.6667C41.0737 60.6667 47.8565 57.8572 52.8575 52.8562C57.8585 47.8552 60.668 41.0724 60.668 34C60.668 26.9276 57.8585 20.1448 52.8575 15.1438C47.8565 10.1429 41.0737 7.33334 34.0013 7.33334ZM39.0013 17.3333C42.043 17.3289 44.9661 18.5126 47.1477 20.6321C49.3293 22.7516 50.597 25.6394 50.6804 28.6799C50.7639 31.7204 49.6566 34.6733 47.5945 36.9093C45.5324 39.1453 42.6786 40.4875 39.6413 40.65L39.0013 40.6667H30.668V47.3333C30.667 48.1829 30.3417 49.0001 29.7585 49.6179C29.1752 50.2357 28.3781 50.6075 27.53 50.6572C26.6818 50.707 25.8467 50.4311 25.1952 49.8858C24.5437 49.3405 24.125 48.567 24.0246 47.7233L24.0013 47.3333V24C24.0008 22.3181 24.636 20.6981 25.7796 19.4648C26.9233 18.2316 28.4908 17.4761 30.168 17.35L30.668 17.3333H39.0013ZM39.0013 24H30.668V34H39.0013C40.2854 33.9994 41.52 33.5048 42.4493 32.6186C43.3786 31.7325 43.9313 30.5229 43.993 29.2403C44.0548 27.9577 43.6207 26.7006 42.7807 25.7293C41.9408 24.7581 40.7594 24.1472 39.4813 24.0233L39.0013 24Z",
    fill: "#64B3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeParking);
export default __webpack_public_path__ + "static/media/home-parking.0e8f6325004fa2c669e00592d44d71cd.svg";
export { ForwardRef as ReactComponent };